var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_10411_12184",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 22.75C18.3848 22.75 22.75 18.3848 22.75 13C22.75 7.61522 18.3848 3.25 13 3.25C7.61522 3.25 3.25 7.61522 3.25 13C3.25 14.7768 3.72529 16.4426 4.55566 17.8772L3.73564 20.9375C3.5198 21.7431 4.25692 22.4802 5.06245 22.2643L8.12278 21.4443C9.55738 22.2747 11.2232 22.75 13 22.75Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55566 17.8772L6.6485 18.438L6.88114 17.5698L6.43085 16.7918L4.55566 17.8772ZM3.73564 20.9375L1.64281 20.3768L3.73564 20.9375ZM5.06245 22.2643L5.62322 24.3572L5.62322 24.3572L5.06245 22.2643ZM8.12278 21.4443L9.20818 19.5691L8.43024 19.1189L7.56201 19.3515L8.12278 21.4443ZM20.5833 13C20.5833 17.1882 17.1882 20.5833 13 20.5833V24.9167C19.5814 24.9167 24.9167 19.5814 24.9167 13H20.5833ZM13 5.41667C17.1882 5.41667 20.5833 8.81184 20.5833 13H24.9167C24.9167 6.41861 19.5814 1.08333 13 1.08333V5.41667ZM5.41667 13C5.41667 8.81184 8.81184 5.41667 13 5.41667V1.08333C6.41861 1.08333 1.08333 6.41861 1.08333 13H5.41667ZM6.43085 16.7918C5.78628 15.6782 5.41667 14.3856 5.41667 13H1.08333C1.08333 15.1681 1.66429 17.207 2.68046 18.9626L6.43085 16.7918ZM5.82848 21.4983L6.6485 18.438L2.46282 17.3164L1.64281 20.3768L5.82848 21.4983ZM4.50168 20.1715C5.30721 19.9557 6.04433 20.6928 5.82848 21.4983L1.64281 20.3768C0.995278 22.7934 3.20662 25.0047 5.62322 24.3572L4.50168 20.1715ZM7.56201 19.3515L4.50168 20.1715L5.62322 24.3572L8.68356 23.5372L7.56201 19.3515ZM13 20.5833C11.6144 20.5833 10.3218 20.2137 9.20818 19.5691L7.03738 23.3195C8.79298 24.3357 10.8319 24.9167 13 24.9167V20.5833Z",
    fill: "#AFAFAF",
    mask: "url(#path-1-inside-1_10411_12184)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.adcbba883a986192afe2b460019f9475.svg";
export { ForwardRef as ReactComponent };